export const baseUrl = 'https://webordersnetcore.bistrosoft.com'
export const mySelfUrl = 'https://weborders.bistrosoft.com'

// export const mySelfUrl = 'http://localhost:8080'
// export const baseUrl = 'http://localhost:5000'



// WEBPACK FOOTER //
// ./src/server.js